import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationType, ConnectorTypes, OrganisationConfiguration } from '@bciti/types';
import { combineLatest, ReplaySubject, Subject } from 'rxjs';
import { map, takeUntil, switchMap, tap } from 'rxjs/operators';
import { AllConnectorsResponse, Connector } from 'src/app/interfaces/config/config.interface';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
    selector: 'app-connectors',
    templateUrl: './connectors.component.html',
    styleUrls: ['./connectors.component.scss'],
})
export class ConnectorsComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();
    reload$ = new ReplaySubject();

    orgTag: string;
    config: OrganisationConfiguration;
    connectors: Connector[];
    configuredConnectors: Connector[];
    connectorTypeLabels = Object.values(ConnectorTypes);

    loading = false;

    // Maybe move to another component
    selectedValue: string;
    matchedConnectors: any[];

    private _selected: number = 0;

    get selected() {
        return this._selected;
    }

    set selected(v: number) {
        this._selected = v;
    }

    constructor(private route: ActivatedRoute, private configurationService: ConfigurationService) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            if (param.tag) {
                this.orgTag = param.tag;

                this.reload$
                    .pipe(
                        takeUntil(this.destroy$),
                        tap(() => (this.loading = true)),
                        switchMap(() =>
                            combineLatest([
                                this.configurationService.getConfigurationByKey(this.orgTag, ConfigurationType.PLATFORM),
                                this.configurationService.getConfigurationByKey('ALL', ConfigurationType.CONNECTORS),
                                this.configurationService.getConfigurationByKey(this.orgTag, ConfigurationType.CONFIGUREDCONNECTORS),
                            ]).pipe(
                                takeUntil(this.destroy$),
                                map(([platform, connectors, configuredConnectors]) => {
                                    this.config = platform;
                                    this.connectors = (connectors as AllConnectorsResponse).connectors;
                                    this.configuredConnectors = configuredConnectors.connectors;
                                    this.loading = false;
                                }),
                            ),
                        ),
                    )
                    .subscribe();

                this.reload$.next();
            }
        });
    }

    handleReload(e) {
        this.reload$.next();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
